import { __assign } from "tslib";
/* eslint-disable react-hooks/rules-of-hooks */
import { useFormLayout } from "../cn-form-layout";
export var mapSize = function (props) {
    var layout = __assign({}, useFormLayout());
    return __assign(__assign({}, props), { size: props.size || layout.size || 'medium' });
};
